// extracted by mini-css-extract-plugin
export default {"item":"bdzzI"};